export default __webpack_public_path__ + "static/slider-3-e16508ff030ad7dffaa2245eeaa6e513.webp";